import classNames from 'classnames'
import { _x } from '@wordpress/i18n'

type FilterToggleProps = {
  variant: 'desktop' | 'mobile'
  modalId?: string
}

function FilterToggle({
  variant,
  modalId = 'filter-modal'
}: FilterToggleProps) {
  const buttonClassNames = classNames(
    'btn btn-sm filter-panel-button filter-modal-toggle',
    variant === 'desktop' &&
      'btn-square--mobile icon-text-hidden--mobile btn-outline-default'
  )

  return (
    <button
      type="button"
      className={buttonClassNames}
      data-bs-toggle="modal"
      data-bs-target={`#${modalId}`}
      aria-label={_x('Open filters', 'Filter Modal Toggle Aria Label', 'icf')}
    >
      <i className="icon fa-sliders" />
      <span>{_x('Filter', 'Filter Button Label', 'icf')}</span>
    </button>
  )
}

export default FilterToggle
